var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1197_49691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3H9.4C7.15979 3 6.03969 3 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3 6.03969 3 7.15979 3 9.4V16.5M17.8 21H9.7C8.57989 21 8.01984 21 7.59202 20.782C7.21569 20.5903 6.90973 20.2843 6.71799 19.908C6.5 19.4802 6.5 18.9201 6.5 17.8V9.7C6.5 8.57989 6.5 8.01984 6.71799 7.59202C6.90973 7.21569 7.21569 6.90973 7.59202 6.71799C8.01984 6.5 8.57989 6.5 9.7 6.5H17.8C18.9201 6.5 19.4802 6.5 19.908 6.71799C20.2843 6.90973 20.5903 7.21569 20.782 7.59202C21 8.01984 21 8.57989 21 9.7V17.8C21 18.9201 21 19.4802 20.782 19.908C20.5903 20.2843 20.2843 20.5903 19.908 20.782C19.4802 21 18.9201 21 17.8 21Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1197_49691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.31e83e7eecf764348115d4984e3e4f02.svg";
export { ForwardRef as ReactComponent };